import { ENGAGEMENT_TAGS } from "../../utilities/utility";


export const UNANSWERED_OPTION = [
    ENGAGEMENT_TAGS.WEEK_1,
    ENGAGEMENT_TAGS.WEEK_1,
    ENGAGEMENT_TAGS.RETENTION_CALL,
    ENGAGEMENT_TAGS.WEEK_3,
    ENGAGEMENT_TAGS.W0_CALL,
    ENGAGEMENT_TAGS.SLOT_BOOKING
];


export const IVR_CALLBACK_CATEGORY = {
    CALL_APPOINTMENT_MGMT: "Call & Appointment Management",
    MEDICAL_COACH_SUPPORT: "Medical & Coach Support",
    ORDER_LOGISTICS: "Order & Logistics",
    PRODUCT_TREATMENT_QUERIES: "Product & Treatment Queries",
    PAYMENTS_REFUNDS: "Payments & Refunds",
    COMPLAINTS_ESCALATIONS: "Complaints & Escalations",
    ACCOUNT_PROFILE: "Account & Profile",
    SALES_LEADS: "Sales & Leads",
    SYSTEM_NON_ACTIONABLE: "System / Non-Actionable",
    OTHER: "Other",
};

export const NON_PRIORITY_DUMMY_DOCTOR = {
    id: 'd8c3c2f7-3963-44b4-8d12-50cef50912e1',
    email: 'nonprioritydummydoctor@traya.health',
    first_name: 'NON PRIORITY DUMMY DOCTOR'
};

export const IVR_CALLBACK_TAGS = {
    // Call & Appointment Management
    CALLBACK_REQUESTED: "Callback Requested",
    DOCTOR_CALL_REQUIRED: "Doctor Call Required",
    MISSED_CALL_MEDICAL_TEAM: "Missed Call from Medical Team",
    APPOINTMENT_RESCHEDULE_REQUEST: "Appointment Reschedule Request",
    APPOINTMENT_CONFIRMATION: "Appointment Confirmation",
    APPOINTMENT_CANCELLATION: "Appointment Cancellation",

    // Medical & Coach Support
    CONSULTATION_COMPLETED: "Consultation Completed",
    CONSULTATION_PENDING: "Consultation Pending",
    FOLLOWUP_CONSULTATION_REQUIRED: "Follow-up Consultation Required",
    DISSATISFIED_WITH_COACH: "Dissatisfied with Coach",
    REQUEST_COACH_CHANGE: "Request for Coach Change",
    MEDICAL_QUERY_CLARIFICATION: "Medical Query Clarification",

    // Order & Logistics
    ORDER_STATUS_INQUIRY: "Order Status Inquiry",
    DELIVERY_DELAY: "Delivery Delay",
    MISSED_DELIVERY: "Missed Delivery",
    ADDRESS_CHANGE_REQUEST: "Address Change Request",
    ORDER_NOT_RECEIVED: "Order Not Received",
    PARTIAL_DELIVERY: "Partial Delivery",
    ORDER_PLACED: "Order Placed",
    ORDER_NOT_PLACED_FINANCIAL_CONCERN: "Order Not Placed - Financial Concern",
    ORDER_NOT_PLACED_NEED_MORE_TIME: "Order Not Placed - Need more time",
    ORDER_NOT_PLACED_ISSUE_WITH_KIT: "Order Not Placed - Issue with kit",
    ORDER_NOT_PLACED_MINOXIDIL_CONCERN: "Order Not Placed - Minoxidil Concern",
    ORDER_NOT_PLACED_WANT_TO_CONSULT_DOCTOR: "Order Not Placed - Want to consult a doctor",
    ORDER_NOT_PLACED_NON_TREATABLE: "Order Not Placed - Non treatable",
    ORDER_NOT_PLACED_GEOGRAPHICAL_RESTRICTION: "Order Not Placed - Geographical Restriction",

    // Product & Treatment Queries
    PRODUCT_USAGE_GUIDANCE: "Product Usage Guidance",
    SIDE_EFFECT_CONCERN: "Side Effect Concern",
    TREATMENT_EFFECTIVENESS_QUERY: "Treatment Effectiveness Query",
    DOSAGE_CLARIFICATION: "Dosage Clarification",
    PRODUCT_REPLACEMENT_REQUEST: "Product Replacement Request",

    // Payments & Refunds
    PAYMENT_FAILURE: "Payment Failure",
    REFUND_REQUESTED: "Refund Requested",
    REFUND_STATUS_CHECK: "Refund Status Check",
    SUBSCRIPTION_PAUSE: "Subscription Pause",
    SUBSCRIPTION_CANCELLATION: "Subscription Cancellation",
    BILLING_DISCREPANCY: "Billing Discrepancy",

    // Complaints & Escalations
    SERVICE_COMPLAINT: "Service Complaint",
    REPEAT_ISSUE: "Repeat Issue",
    ESCALATION_REQUESTED: "Escalation Requested",
    SLA_BREACH: "SLA Breach",
    QUALITY_CONCERN: "Quality Concern",

    // Account & Profile
    PROFILE_UPDATE: "Profile Update",
    LOGIN_ISSUE: "Login Issue",
    REGISTERED_NUMBER_CHANGE: "Registered Number Change",
    APP_WEBSITE_ISSUE: "App / Website Issue",

    // Sales & Leads
    NEW_LEAD_INQUIRY: "New Lead Inquiry",
    PRICING_INQUIRY: "Pricing Inquiry",
    OFFER_DISCOUNT_QUERY: "Offer / Discount Query",
    NOT_INTERESTED: "Not Interested",
    FOLLOWUP_REQUIRED: "Follow-up Required",

    // System / Non-Actionable
    WRONG_NUMBER: "Wrong Number",
    CALL_DROPPED: "Call Dropped",
    TEST_CALL: "Test Call",
    DUPLICATE_INTERACTION: "Duplicate Interaction",
    NO_RESPONSE_FROM_CUSTOMER: "No Response from Customer",
};


export const IVR_CALLBACK_CATEGORY_MAP = {
    [IVR_CALLBACK_CATEGORY.CALL_APPOINTMENT_MGMT]: [
        IVR_CALLBACK_TAGS.CALLBACK_REQUESTED,
        IVR_CALLBACK_TAGS.DOCTOR_CALL_REQUIRED,
        IVR_CALLBACK_TAGS.MISSED_CALL_MEDICAL_TEAM,
        IVR_CALLBACK_TAGS.APPOINTMENT_RESCHEDULE_REQUEST,
        IVR_CALLBACK_TAGS.APPOINTMENT_CONFIRMATION,
        IVR_CALLBACK_TAGS.APPOINTMENT_CANCELLATION,
    ],
    [IVR_CALLBACK_CATEGORY.MEDICAL_COACH_SUPPORT]: [
        IVR_CALLBACK_TAGS.CONSULTATION_COMPLETED,
        IVR_CALLBACK_TAGS.CONSULTATION_PENDING,
        IVR_CALLBACK_TAGS.FOLLOWUP_CONSULTATION_REQUIRED,
        IVR_CALLBACK_TAGS.DISSATISFIED_WITH_COACH,
        IVR_CALLBACK_TAGS.REQUEST_COACH_CHANGE,
        IVR_CALLBACK_TAGS.MEDICAL_QUERY_CLARIFICATION,
    ],
    [IVR_CALLBACK_CATEGORY.ORDER_LOGISTICS]: [
        IVR_CALLBACK_TAGS.ORDER_STATUS_INQUIRY,
        IVR_CALLBACK_TAGS.DELIVERY_DELAY,
        IVR_CALLBACK_TAGS.MISSED_DELIVERY,
        IVR_CALLBACK_TAGS.ADDRESS_CHANGE_REQUEST,
        IVR_CALLBACK_TAGS.ORDER_NOT_RECEIVED,
        IVR_CALLBACK_TAGS.PARTIAL_DELIVERY,
        IVR_CALLBACK_TAGS.ORDER_PLACED,
        IVR_CALLBACK_TAGS.ORDER_NOT_PLACED_FINANCIAL_CONCERN,
        IVR_CALLBACK_TAGS.ORDER_NOT_PLACED_NEED_MORE_TIME,
        IVR_CALLBACK_TAGS.ORDER_NOT_PLACED_ISSUE_WITH_KIT,
        IVR_CALLBACK_TAGS.ORDER_NOT_PLACED_MINOXIDIL_CONCERN,
        IVR_CALLBACK_TAGS.ORDER_NOT_PLACED_WANT_TO_CONSULT_DOCTOR,
        IVR_CALLBACK_TAGS.ORDER_NOT_PLACED_NON_TREATABLE,
        IVR_CALLBACK_TAGS.ORDER_NOT_PLACED_GEOGRAPHICAL_RESTRICTION,
    ],
    [IVR_CALLBACK_CATEGORY.PRODUCT_TREATMENT_QUERIES]: [
        IVR_CALLBACK_TAGS.PRODUCT_USAGE_GUIDANCE,
        IVR_CALLBACK_TAGS.SIDE_EFFECT_CONCERN,
        IVR_CALLBACK_TAGS.TREATMENT_EFFECTIVENESS_QUERY,
        IVR_CALLBACK_TAGS.DOSAGE_CLARIFICATION,
        IVR_CALLBACK_TAGS.PRODUCT_REPLACEMENT_REQUEST,
    ],
    [IVR_CALLBACK_CATEGORY.PAYMENTS_REFUNDS]: [
        IVR_CALLBACK_TAGS.PAYMENT_FAILURE,
        IVR_CALLBACK_TAGS.REFUND_REQUESTED,
        IVR_CALLBACK_TAGS.REFUND_STATUS_CHECK,
        IVR_CALLBACK_TAGS.SUBSCRIPTION_PAUSE,
        IVR_CALLBACK_TAGS.SUBSCRIPTION_CANCELLATION,
        IVR_CALLBACK_TAGS.BILLING_DISCREPANCY,
    ],
    [IVR_CALLBACK_CATEGORY.COMPLAINTS_ESCALATIONS]: [
        IVR_CALLBACK_TAGS.SERVICE_COMPLAINT,
        IVR_CALLBACK_TAGS.REPEAT_ISSUE,
        IVR_CALLBACK_TAGS.ESCALATION_REQUESTED,
        IVR_CALLBACK_TAGS.SLA_BREACH,
        IVR_CALLBACK_TAGS.QUALITY_CONCERN,
    ],
    [IVR_CALLBACK_CATEGORY.ACCOUNT_PROFILE]: [
        IVR_CALLBACK_TAGS.PROFILE_UPDATE,
        IVR_CALLBACK_TAGS.LOGIN_ISSUE,
        IVR_CALLBACK_TAGS.REGISTERED_NUMBER_CHANGE,
        IVR_CALLBACK_TAGS.APP_WEBSITE_ISSUE,
    ],
    [IVR_CALLBACK_CATEGORY.SALES_LEADS]: [
        IVR_CALLBACK_TAGS.NEW_LEAD_INQUIRY,
        IVR_CALLBACK_TAGS.PRICING_INQUIRY,
        IVR_CALLBACK_TAGS.OFFER_DISCOUNT_QUERY,
        IVR_CALLBACK_TAGS.NOT_INTERESTED,
        IVR_CALLBACK_TAGS.FOLLOWUP_REQUIRED,
    ],
    [IVR_CALLBACK_CATEGORY.SYSTEM_NON_ACTIONABLE]: [
        IVR_CALLBACK_TAGS.WRONG_NUMBER,
        IVR_CALLBACK_TAGS.CALL_DROPPED,
        IVR_CALLBACK_TAGS.TEST_CALL,
        IVR_CALLBACK_TAGS.DUPLICATE_INTERACTION,
        IVR_CALLBACK_TAGS.NO_RESPONSE_FROM_CUSTOMER,
    ],
    // Note: OTHER category is not included in the map (uses freetext textarea)
};


export const ENGAGEMENT_REQUEST_TYPE = {
    _15_DAY_COACH_BOOKING: '15day_coach_booking',
    _15_DAY_COACH_LEAD_BOOKING: '15day_coach_lead_booking',
    OFFLINE_INTERACTION: 'OFFLINE_INTERACTION',
    APP_BOOKING: 'app_booking',
    APP_LEAD_BOOKING: 'app_lead_booking',
    FORCED_SLOT: 'forced_slot',
    IVR_LEAD_CALL: 'ivr_lead_call',
    STORE_APP_BOOKING: 'store_app_booking',
    STORE_APP_LEAD_BOOKING: 'store_app_lead_booking',
    STORE_WEBSITE_BOOKING: 'store_website_booking',
    STORE_WEBSITE_LEAD_BOOKING: 'store_website_lead_booking',
    WEBSITE_BOOKING: 'website_booking',
    WEBSITE_LEAD_BOOKING: 'website_lead_booking'
}


export const DISPOSITION_ANSWERS = {
    CALL_RESPONSE: {
        ANSWERED: 'answered',
        UNANSWERED: 'unanswered',
        SHORT_CALLS: 'shortCalls',
        LANGUAGE_ISSUE: 'languageIssue',
        DND_MODE: 'dndMode',
        OVERLAP: 'overlap',
    },
    UNANSWERED_OPTION: {
        SCRIPT_UNFULFILLED: 'script_unfullfill',
        CX_WANTS_CALLBACK: 'cx_wants_callBack',
        DID_NOT_PICK_UP: 'did_not_pick_up',
        DONT_WANT_TALK: 'dont_want_talk',
    },
    IS_DOCTOR_REQUIRED: {
        YES: 'yes',
        NO: 'no',
    },
    REGULARITY: {
        REGULAR: 'regular',
        IRREGULAR: 'irregular',
    },
    MOOD: {
        NO_CHANGE:'No Change',
        SOME_CHANGE:'Some Change',
        IMPROVEMENT:'Improvement',
    },
    REACTION: {
        YES: 'yes',
        NO: 'no',
    },
    SATISFACTION: {
        SAD: 'Sad',
        INDIFFERENT: 'Indifferent',
        HAPPY: 'Happy',
    },
    REASON: {
        TRAVEL: 'Travel',
        ILL: 'Ill',
        WORK: 'Work',
        PRODUCTS: 'Products',
        DIET: 'Diet'
    }
}


export const FORM_DISPOSITION = [
    DISPOSITION_ANSWERS.CALL_RESPONSE.UNANSWERED,
    DISPOSITION_ANSWERS.CALL_RESPONSE.LANGUAGE_ISSUE,
    DISPOSITION_ANSWERS.CALL_RESPONSE.DND_MODE
];


export const DISPOSITION_COMPONENTS = {
    CALL_RESPONSE: 'callResponse',
    MOOD: 'mood',
    COMMENTS: 'comments',
    REGULARITY: 'regularity',
    REACTION: 'reaction',
    SUBCATEGORY: 'Sub-category',
    PRODUCTS: 'Products Reactions',
    REASON: 'reason',
    GUT_HEALTH: 'gutHealth',
    ENERGY: 'energy',
    HAIR_LOSS: 'hairLoss',
    HAIR_GROWTH: 'hairGrowth',
    REASON_FOR_NOT_ORDERING: 'reasonForNotOrdering',
}


export const IVR_CALL_UNANSWERED_OPTIONS = [
    { value: 'cx_not_audible', label: 'Customer voice not audible'},
    { value: 'agent_not_audible', label: 'Agent voice not audible'},
    { value: 'blank_call', label: 'Blank call'},
    { value: 'call_dropped_on_pick_up', label: 'Call dropped on pick up'},
    { value: 'call_dropped_in_between', label: 'Call dropped in between'},
    { value: 'script_unfulfill', label: 'Partially answered because not able to cover all the elements of the script!'},
    { value: 'dont_want_talk', label: 'Customer pickup but does not want to talk!'},
    { value: 'did_not_pick_up', label: 'Customer did not pick up!'},
    { value: 'cx_wantsCallBack', label: 'Customer pickup but wants a call back later!'}
]

const PC_SLOT_HIDDEN_TAGS = new Set([
  ENGAGEMENT_TAGS.WEEK_3,
  ENGAGEMENT_TAGS.WEEK_1,
  ENGAGEMENT_TAGS.W0_CALL,
  ENGAGEMENT_TAGS.RETENTION_CALL,
  ENGAGEMENT_TAGS.PRESCRIPTION_CALL,
]);

export const isPCSlotHidden = (week) => PC_SLOT_HIDDEN_TAGS.has(week);

const FIFTEEN_DAY_SLOT_DISABLED_CASE_ID_CHARS = new Set(['5','6','7','8','9','c','d','e','f']);

export const is15DaySlotDisabled = (week, orderCount, caseId) => {
  const isTargetEngagement = [ENGAGEMENT_TAGS.WEEK_3, ENGAGEMENT_TAGS.SLOT_BOOKING].includes(week);
  const isTargetOrderCount = orderCount >= 2 && orderCount <= 4;
  const firstChar = caseId?.charAt(0)?.toLowerCase();
  const isTargetCaseId = FIFTEEN_DAY_SLOT_DISABLED_CASE_ID_CHARS.has(firstChar);
  return isTargetEngagement && isTargetOrderCount && isTargetCaseId;
};

export const isAllowedLeadBookingType = (requestType) => {
  const allowedTypes = [
    ENGAGEMENT_REQUEST_TYPE.WEBSITE_LEAD_BOOKING,
    ENGAGEMENT_REQUEST_TYPE.APP_LEAD_BOOKING,
    ENGAGEMENT_REQUEST_TYPE._15_DAY_COACH_LEAD_BOOKING,
  ];
  return allowedTypes.includes(requestType);
};
